/**
 * Default seed for DSOK Daily Menu Screen settings (jedno nastavenie pre landscape aj portrait).
 * Used when localStorage key dsok.dailyMenu.screenSettings.v1 is empty.
 */
const DEFAULT_TICKER_TEXTS = {
  "sk-SK":
    "Vitajte v našej reštaurácii. Denné menu pripravujeme čerstvé každý deň. Prajeme vám dobrú chuť!",
  "en-US":
    "Welcome to our restaurant. Our daily menu is freshly prepared every day. Enjoy your meal!",
};

function buildDefaultSettings() {
  return {
    enabled: true,
    logo: "",
    template: "",
    mainTitle: {},
    contentRotation: "none",
    languages: "sk-SK_en-US",
    languageRotationEnabled: true,
    languageRotationIntervalSec: 5,
    pageRotationIntervalSec: 8,
    menuTypeCheckIntervalMin: 5,

    // Striedanie denného a týždenného menu (LEN portrait obrazovka).
    // Keď je zapnuté, v intervale weeklyMenuRotationIntervalSec sa strieda
    // aktuálne denné menu (raňajky/obed/večera) s týždenným menu.
    weeklyMenuRotationEnabled: false,
    weeklyMenuRotationIntervalSec: 60,
    // Typ menu zobrazený v týždennom pohľade (breakfast|lunch|dinner|night).
    weeklyMenuType: "lunch",

    maxMealsPerPageLandscape: 5,
    maxMealsPerPagePortrait: 6,
    productDisplayTypeLandscape: "list",
    productDisplayTypePortrait: "list",
    showUnavailableProducts: true,
    sortUnavailableToEnd: true,
    showDescription: true,
    showAllergens: true,
    showPrices: true,

    tickerEnabled: true,
    tickerTexts: { ...DEFAULT_TICKER_TEXTS },
    tickerSpeed: 60,

    // WEB Export (viditeľný len ak je pre zákazníka povolené
    // customer.customerUISettings.enableDailyMenuWebExport). Názvy súborov sú fixné
    // (breakfast/lunch/dinner_1/2.json), nie sú súčasťou nastavení.
    webExport: {
      days: {
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: false,
        sunday: false,
      },
    },
  };
}

export const defaultScreenSettings = buildDefaultSettings();
export default defaultScreenSettings;
